import { render, staticRenderFns } from "./association-form.vue?vue&type=template&id=a205b552&scoped=true"
import script from "./association-form.vue?vue&type=script&lang=js"
export * from "./association-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a205b552",
  null
  
)

export default component.exports